import { render } from "./Navigatie.vue?vue&type=template&id=73d1fbee&scoped=true"
import script from "./Navigatie.vue?vue&type=script&lang=js"
export * from "./Navigatie.vue?vue&type=script&lang=js"

import "./Navigatie.vue?vue&type=style&index=0&id=73d1fbee&scoped=true&lang=css"

import exportComponent from "/Users/vincent/Documents/GIT_CLONES/skipiste/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73d1fbee"]])

export default __exports__